import Vue from 'vue';

// Explicit mapping confirmed by Andrea's review for the WPML language codes
// expected by the WordPress REST API (see
// https://tourial.it/blog/wp-json/wp/v2/posts?lang=pt-pt). Add an entry here
// once a language's WPML code is confirmed.
//
// Italian maps to `null`: it's WPML's default language on the WordPress
// site, and WPML returns the default-language content when `lang` is
// omitted entirely — passing `lang=it` is not equivalent and must be avoided.
//
const ISO_TO_WPML_LOCALE = {
    en: 'en',
    fr: 'fr',
    es: 'es',
    de: 'de',
    pt: 'pt-pt',
    zh: 'zh-hant',
    it: null,
};

// Returns the WPML language code for the given app locale: the confirmed
// mapping above, `null` when no `lang` query param should be sent (the
// WordPress default language), or the locale unchanged when it has no
// confirmed mapping yet.
export function toWpmlLocale(isoLocale) {
    if (!isoLocale) return null;
    const normalized = isoLocale.toLowerCase();
    return normalized in ISO_TO_WPML_LOCALE ? ISO_TO_WPML_LOCALE[normalized] : normalized;
}

// `$i18n.locale` starts out as a provisional guess (browser language, see
// src/utils/i18n-factory.js) and gets overwritten once App.vue finishes
// resolving whether there's a logged-in user and, if so, applies their
// saved profile language (see App.vue's `user` watcher). Anything that
// requests WPML content by language must wait for this flag before firing
// its first request, otherwise it fetches once with the provisional guess
// and again with the real locale.
//
// This mirrors App.vue's own `userLoaded` flag rather than reusing it as a
// prop, because Post.vue can mount two different ways: as a named router-view
// (props can be bound normally) or inside a $showPanel/BreadCumbWrapper panel,
// which snapshots the props it's given at the moment the panel opens and
// never updates them again. If Post.vue is opened (e.g. via a direct link to
// a post) before `userLoaded` flips true, a prop-drilled value would freeze
// at its stale `false`/`null` snapshot forever. Importing this observable
// directly sidesteps that snapshot and stays live regardless of how Post.vue
// was mounted. Same idiom as `$FEATURES`/`$TARGETS` in main.js.
export const localeReadiness = Vue.observable({ ready: false });
